@if (summary) {
  <lib-subheadline [subheadline]="'aiProfileMatching.summary'"></lib-subheadline>
  <p class="analyze-result__summary">{{ summary }}</p>
}

<lib-subheadline [subheadline]="'aiProfileMatching.strengths'"></lib-subheadline>
<mat-list>
  @for (strength of strengths; track strength; let last = $last) {
    <ng-container>
      <p>{{ strength }}</p>
      @if (!last) {
        <mat-divider></mat-divider>
      }
    </ng-container>
  }
</mat-list>

@if (weaknesses.length > 0) {
  <lib-subheadline [subheadline]="'aiProfileMatching.weaknesses'"></lib-subheadline>
  <mat-list>
    @for (weakness of weaknesses; track weakness; let last = $last) {
      <ng-container>
        <p>{{ weakness }}</p>
        @if (!last) {
          <mat-divider></mat-divider>
        }
      </ng-container>
    }
  </mat-list>
}

<lib-subheadline [subheadline]="'aiProfileMatching.gaps'"></lib-subheadline>
<mat-list>
  @for (gap of gaps; track gap; let last = $last) {
    <ng-container>
      <p>{{ gap }}</p>
      @if (!last) {
        <mat-divider></mat-divider>
      }
    </ng-container>
  }
</mat-list>

@if (matches.length > 0) {
  <lib-subheadline [subheadline]="'aiProfileMatching.matches'"></lib-subheadline>
  <mat-list>
    @for (match of matches; track match; let last = $last) {
      <ng-container>
        <p>{{ match }}</p>
        @if (!last) {
          <mat-divider></mat-divider>
        }
      </ng-container>
    }
  </mat-list>
}

<lib-subheadline [subheadline]="'aiProfileMatching.recommendations'"></lib-subheadline>
<mat-list>
  @for (recommendation of recommendations; track recommendation; let last = $last) {
    <ng-container>
      <p>{{ recommendation }}</p>
      @if (!last) {
        <mat-divider></mat-divider>
      }
    </ng-container>
  }
</mat-list>
